import React from 'react'
import ausbg from '../../assets/imgnew/elitebg2.jpg'
import sat from '../../assets/courselogo/satlogo.png'


export default function Satpage() {
  return (
    <>
         {/* hero section start */}
  <div id='#customcontainer' className="customcontainer mt-4 pt-3">
 <div className="bg-image d-flex justify-content-center mt-5 align-items-center" style={{
  backgroundImage: `url(${ausbg})`,
  height: '500px',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  backgroundBlendMode: 'overlay'
}}>
    <div className="row landingformlayout w-100 mx-0 px-5 mt-5">
    <div className="col-md-8 ieltslandingcontent">
     <h1 className="bannerHeading text-light">Improve Your SAT Score With GlobEDwise</h1>
		<ul className="bannerPoints text-dark">
			<li className='my-3 ullist text-light'><i className="fa fa-check-circle"></i> SAT is a standardized test administered by the College Board</li>
			<li className='my-3 ullist text-light'><i className="fa fa-check-circle"></i> Required to be taken by students seeking admission to undergraduate schools</li>
			<li className='my-3 ullist text-light'><i className="fa fa-check-circle"></i> SATs has been developed to evaluate the written, verbal and mathematical skills of the candidates</li>
			<li className='my-3 ullist text-light'><i className="fa fa-check-circle"></i> The full form of SAT is the Scholastic Assessment Test</li>
			<li className='my-3 ullist text-light'><i className="fa fa-check-circle"></i> The SAT is divided into two sections, Reading, Writing, and Mathematics.</li>
			
		</ul>
        <img src={sat} className='rounded-3' style={{width:'120px'}} alt='flag'/>
     </div>

     <div className="ieltslandingcontentmobile" style={{display:'none'}}>
     <h1 className="bannerHeading text-light">Boost Your GMAT Score With GlobEDwise</h1>
</div>



    </div>
 
</div>

 </div>
{/* hero section ended */}

<div className="section-head col-sm-12 mb-1 mt-3">
        <h4><span>SAT</span></h4>
    </div>

<div className="container">
    <h5>What is SAT Exam?</h5>
    <p>SAT is a standardized test administered by the College Board and is required to be taken by students seeking admission to undergraduate schools. The full form of SAT is the Scholastic Assessment Test, which was earlier known as the Scholastic Aptitude Test. SATs has been developed to evaluate the written, verbal and mathematical skills of the candidates.</p>

    <h5>SAT is a pencil-paper test</h5>
    <p>taken by those who aspire to pursue undergraduate courses, particularly in the US and Canada are required to take the SAT exam. SAT helps students on their path to college. Earlier, students looking to get admission to a particular course needed to take the SAT subject test but now SAT Subjects are discontinued by the College Board from June 2021.</p>

    <table className="table table-bordered">
            <thead className="table-dark">
                <tr>
                    <th>Exam Name</th>
                    <td>SAT</td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th>Full Form</th>
                    <td>Scholastic Assessment Test</td>
                </tr>
                <tr>
                    <th>Official Website</th>
                    <td><a href="https://collegereadiness.collegeboard.org/sat" target="blank">https://collegereadiness.collegeboard.org/sat</a></td>
                </tr>
                <tr>
                    <th>Most popular for</th>
                    <td>Undergraduate courses in the US and Canada</td>
                </tr>
                <tr>
                    <th>Conducted by</th>
                    <td>The College Board</td>
                </tr>
                <tr>
                    <th>Mode of Exam</th>
                    <td>Written-based examination</td>
                </tr>
                <tr>
                    <th>Exam Fees</th>
                    <td>$109</td>
                </tr>
                <tr>
                    <th>Score Range</th>
                    <td>400-1600 points</td>
                </tr>
            </tbody>
        </table>

        <p>The SAT is divided into two sections, Reading, Writing, and Mathematics. These two sections are scored on a 200-800 point scale, for a maximum total score of 1600. There are additional subscores reported on a 20-80 scale. The scores of a student reflect on how he/she is compared with other students who have appeared for the test. Visit SAT Score Reporting for a detailed understanding of calculating SAT score.</p>

        <h5>SAT Score Range: What's a Good SAT Score for Colleges?</h5>
        <p>An average SAT score is around 1000. Anything above 1200 is considered a good SAT score. The maximum anyone can score on the SAT is the perfect score of 1600. Since you receive scaled scores, you should have some understanding of SAT scaled scores and percentiles.</p>

        <h5>How to Send SAT Scores to Colleges?</h5>
        <p>There are two ways of sending the scores to colleges:</p>
        <ul>
            <li>One while registering for the test or</li>
            <li>After releasing the official scores</li>
        </ul>
        <p>Candidates receive four free Score Reports while registering for the SAT test. Candidates can send the scores to colleges up to nine days of taking the test after that they have to pay $12 for sending the score reports to each university/program they choose.</p>

        <h5>SAT v/s ACT: Which Test to Take?</h5>
        <p>Both SAT and ACT, have questions from similar topics and are used for college admissions. Candidates can study the difference between SAT vs ACT from the comparison given below:</p>

        <table className="table table-bordered">
            <thead className="table-dark">
                <tr>
                    <th>Parameters</th>
                    <th>SAT</th>
                    <th>ACT</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Purpose</td>
                    <td>For college admissions and merit-based scholarships.</td>
                    <td>For college admissions and merit-based scholarships.</td>
                </tr>
                <tr>
                    <td>Test Structure</td>
                    <td>
                        <ul>
                            <li>Reading</li>
                            <li>Writing & Language</li>
                            <li>Math</li>
                            <li>Essay (Optional)</li>
                        </ul>
                    </td>
                    <td>
                        <ul>
                            <li>English</li>
                            <li>Math</li>
                            <li>Reading</li>
                            <li>Science Reasoning</li>
                            <li>Essay (Optional)</li>
                        </ul>
                    </td>
                </tr>
                <tr>
                    <td>Length</td>
                    <td>3 hours (without essay)<br/>3 hours, 50 minutes (with essay)</td>
                    <td>2 hours, 55 minutes (without essay)<br/>3 hours, 40 minutes (with essay)</td>
                </tr>
                <tr>
                    <td>Reading</td>
                    <td>5 reading passages</td>
                    <td>4 reading passages</td>
                </tr>
                <tr>
                    <td>Science</td>
                    <td>None</td>
                    <td>1 science section accessing critical thinking skills and not specific science knowledge</td>
                </tr>
                <tr>
                    <td>Math</td>
                    <td>
                        <ul>
                            <li>Arithmetic</li>
                            <li>Algebra I & II</li>
                            <li>Geometry, Trigonometry and Data Analysis</li>
                            <li>Calculator usage: Allowed for a few mathematics questions</li>
                        </ul>
                    </td>
                    <td>
                        <ul>
                            <li>Arithmetic</li>
                            <li>Algebra I & II</li>
                            <li>Geometry, Trigonometry, and Probability & Statistics</li>
                            <li>Calculator usage: Allowed for all mathematics questions</li>
                        </ul>
                    </td>
                </tr>
                <tr>
                    <td>Essays</td>
                    <td>Optional</td>
                    <td>Optional</td>
                </tr>
                <tr>
                    <td>Score Scale</td>
                    <td>400–1600</td>
                    <td>1–36</td>
                </tr>
            </tbody>
        </table>

        <h4 className="mb-4 text-danger">SAT FAQs</h4>

<h6>Q .Can I take the SAT exam after the 12th?</h6>
<p>A: There are no specific age criteria laid down by The College Board for appearing for your SAT exam.
    However, since SAT is for admission to undergraduate programs candidates are advised to
    appear for their SAT while in standard 11 or 12.</p>

<h6>Q .Is the SAT examination in the US and Asia the same?</h6>
<p>A: Both, the SAT examination held in the US and Asia would be in English and contain the exact
    number of questions. However, The College Board uses different versions of the test in a single day.</p>

<h6>Q .Do Indian colleges take admission through SAT scores?</h6>
<p>A: All Indian Universities that are affiliated with the India Higher Education Alliance, introduced by
    The College Board are accepting SAT scores for admissions. For a list of Indian academic universities
    accepting SAT scores, click here.</p>

<h6>Q .What is an SAT Superscore?</h6>
<p>A: SAT Superscore is the combined score of your total scores in each section. In simple words, it is
    the total of your highest scores in each section. Read more about SAT Superscore here.</p>

<h6>Q .Which colleges Super score SAT 2022?</h6>
<p>A: You can check the list of colleges accepting SAT Superscore.</p>

<h6>Q .When should I take the SAT exam?</h6>
<p>A: Usually, students take the SAT while attending their high school either in the 11th or 12th
    standard. Candidates should plan the test in such a way that they have the SAT scores with them at
    the time of applying to the colleges.</p>

<h6>Q .Can I use a calculator while giving the SAT exam?</h6>
<p>A: The College Board allows candidates to use calculators for certain sections of the exam, however,
    candidates need to bring their calculators. Test takers are also advised to check the type of calculator
    they can use while giving the SAT test as the College Board does not allow all types of calculators.
    Also, test takers are not allowed to share it as well.</p>

<h6>Q .What is PSAT? How it is different from the SAT test?</h6>
<p>A: PSAT or Preliminary SAT is more like a practice test that candidates give to check their readiness
    for the SAT exam. The PSAT exam takes place once a year in October. Candidates can check the
    nearby school where they can register for the PSAT. The cost for taking PSAT is $17 (INR 1233)
    approximately. Also, it is scored out of 1520, unlike the SAT test that is scored out of 1600.
    Usually, students in class 9th or class 10th give the PSAT. Students in class 11th also give PSAT if they are
    not planning to attempt the SAT exam in 11th standard. It tests the problem-solving skills in three
    areas: Math, Writing, and Critical Reading.</p>

<h6>Q .Is the SAT math test difficult?</h6>
<p>A: One can check the difficulty level of the SAT math test with the progress of the test. The
    difficulty level of the SAT math test increases as the test progresses. The first few questions of the
    test are comparatively easy and then it becomes difficult as you move ahead with the test.</p>

<h6>Q .What types of questions are asked in the SAT exam?</h6>
<p>A: The SAT test includes 4 sections Reading, Writing & Language, Math, and Essay (Optional). Each
    section is designed to monitor a different set of skills of the test takers.</p>

<h6>Q .What is SAT score validity?</h6>
<p>A: The SAT score is valid for a period of 5 years, from the day of the declaration of your SAT
    Result.</p>

        </div>
    </>
  )
}
